import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'boolLabel'
})
export class BoolLabelPipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  transform(value: boolean, ...args: unknown[]): string {
    return value ? 'Common.Yes' : 'Common.No';
  }

}
